import { defineComponent as _defineComponent } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { PaginationRoot, useForwardPropsEmits } from 'reka-ui';
import { cn } from './../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Pagination',
    props: {
        page: { type: Number, required: false },
        defaultPage: { type: Number, required: false },
        itemsPerPage: { type: Number, required: true },
        total: { type: Number, required: false },
        siblingCount: { type: Number, required: false },
        disabled: { type: Boolean, required: false },
        showEdges: { type: Boolean, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    emits: ["update:page"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const delegatedProps = reactiveOmit(props, 'class');
        const forwarded = useForwardPropsEmits(delegatedProps, emits);
        const __returned__ = { props, emits, delegatedProps, forwarded, get PaginationRoot() { return PaginationRoot; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
